export default "__VITE_ASSET__f83aae4b__"